// extracted by mini-css-extract-plugin
module.exports = {"component":"_3TeXDYltOmmT693ToOlEmQ","footerContainer":"_26doMiCmQcUKb79wwX1x3J"};